import checklists from "./checklists";

export default {
  ...checklists,
};
